import { Instagram } from "lucide-react";
import { useTranslation } from "react-i18next";

const InstagramSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-16 bg-secondary">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2 md:mb-3">
          {t("instagram.title")}<span className="text-accent">{t("instagram.titleAccent")}</span>
        </h2>
        <p className="text-muted-foreground text-sm md:text-base mb-6 md:mb-8 max-w-xl mx-auto">{t("instagram.desc")}</p>
        <a
          href="https://www.instagram.com/wypukle.pl/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 gradient-gold text-accent-foreground font-bold px-8 py-4 rounded-lg hover:opacity-90 transition-opacity shadow-gold"
        >
          <Instagram className="w-5 h-5" />
          {t("instagram.cta")}
        </a>
      </div>
    </section>
  );
};

export default InstagramSection;
